import { useTranslation } from 'react-i18next';
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';
import { ResponsiveDialog } from '@/components/common/ResponsiveDialog';

interface ServiceBookOverrideDialogProps {
  open: boolean;
  value: string;
  onChange: (value: string) => void;
  onClose: () => void;
  onSubmit: () => void;
  submitting?: boolean;
}

export function ServiceBookOverrideDialog({
  open,
  value,
  onChange,
  onClose,
  onSubmit,
  submitting = false,
}: ServiceBookOverrideDialogProps) {
  const { t } = useTranslation('workorders');
  const { t: tc } = useTranslation('common');
  const canSubmit = value.trim().length > 0;

  return (
    <ResponsiveDialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      mobileTitle={t('serviceBook.overrideTitle')}
    >
      <DialogTitle>{t('serviceBook.overrideTitle')}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          multiline
          minRows={2}
          maxRows={4}
          value={value}
          onChange={(event) => { onChange(event.target.value); }}
          label={t('serviceBook.overrideReason')}
          sx={{ mt: 1 }}
          inputProps={{ 'data-testid': 'service-book-override-reason' }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={submitting}>
          {tc('cancel')}
        </Button>
        <Button
          variant="contained"
          onClick={onSubmit}
          disabled={submitting || !canSubmit}
          data-testid="service-book-override-submit"
        >
          {t('serviceBook.overrideSubmit')}
        </Button>
      </DialogActions>
    </ResponsiveDialog>
  );
}
